







































import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/lock'

export default
  name: 'login',
  data: ->
    original_query = @$router.currentRoute.query.original_query
    if original_query && original_query.email && original_query.password
      email    = original_query.email
      password = original_query.password
      delete original_query.email
      delete original_query.password
    return {
      form:
        email: email
        password: password
        remember_me: true
        token: null
        captcha: ''
      formValid: true
    }
  beforeCreate: -> @$store.dispatch 'loginUserFromLocalStorage'
  mounted: ->
    turnstile.ready =>
      window.turnstileWidgetId = turnstile.render '#turnstile',
        sitekey: '0x4AAAAAAAXjOSwdfjhZlca7'
        callback: (token) =>
          console.log token
          @form.captcha = token
    if @form.email
      @loginWithToken() if @form.token
      @loginWithPassword() if @form.password

  methods:
    loginWithToken: ->
      @$store.dispatch('loginUser', { form: @form }).then =>
        @$store.dispatch('redirectUser')
    loginWithPassword: ->
      @$store.dispatch('loginUser', { form: @form }).then =>
        @$store.dispatch('redirectUser')
    quickLogin: (email) ->
      @form.email = email
      @form.password = '111111'
      @loginWithPassword()

